export default __webpack_public_path__ + "static/media/VS.e52ce2d0.PNG";